<template>
    <div class='header' @dragover.prevent="handleDragOver" @drop.prevent="handleDrop">
        <p class='name'> {{ name }} 様 </p>
        <div class='select is-medium'>
            <select class="native-select" @change='changeSchool'>
                <option v-for="(school, key) in schoolMap" :key="key" :value="key"> {{ school.name }} </option>
            </select>
        </div>
        <div class='select is-medium' v-if='schoolMap[selectSchoolId]'>
            <select class="native-select" @change='changeYear'>
                <option v-for="(year, key) in schoolMap[selectSchoolId].years" :key="key" :value="key"> {{ year.name }} </option>
            </select>
        </div>
        <div class='select is-medium' v-if='schoolMap[selectSchoolId] && schoolMap[selectSchoolId].years[selectYearId]'>
            <select class="native-select" v-model='selectEventId' @change='changeEvent'>
                <option v-for="event in orderedEvents" :key="event.id" :value="event.id"> {{ event.name }} </option>
            </select>
        </div>
    </div>
</template>

<script>

import upload from '@/helpers/upload'
import { compareFileNames, readDirectoryFiles } from '@/helpers/uploadFiles'

export default {
    name: 'Header',
    props: ['schoolMap'],
    data () {
        return {
            selectSchoolId: 0,
            selectYearId: 0,
            selectEventId: 0,
            name: '',
            schoolLoaded: false
        }
    },
    computed: {
        orderedEvents () {
            const school = this.schoolMap[this.selectSchoolId]
            const year = school && school.years[this.selectYearId]
            if (!year) return []
            return Object.keys(year.events).map(id => ({ ...year.events[id], id })).sort(compareFileNames)
        }
    },
    watch: {
        schoolMap () {
            this.schoolLoaded = true
            this.selectSchoolId = Object.keys(this.schoolMap)[0]
        },
        selectSchoolId () {
            if (this.schoolMap[this.selectSchoolId]) {
                this.$root.$emit('setPhotoGrapherData', { name: 'selectSchoolId', value: this.selectSchoolId })
                this.selectYearId = Object.keys(this.schoolMap[this.selectSchoolId].years)[0]
            }
        },
        selectYearId () {
            if (this.schoolMap[this.selectSchoolId].years[this.selectYearId]) {
                this.selectEventId = this.orderedEvents.length ? this.orderedEvents[0].id : undefined
            }
        },
        selectEventId () {
            if (this.schoolLoaded) {
                this.changeSelect()
            }
        }
    },
    created () {
        const self = this
        self.selectSchoolId = self.$parent.selectSchoolId

        self.axios.get(`${process.env.API_URL}/name`).then((res) => {
            if (res.data.message === 'OK') {
                self.name = res.data.name
            }
        }).catch((e) => {
            alert('サーバーエラーが発生しました')
        })
    },
    methods: {
        changeSchool (e) {
            this.selectSchoolId = e.target.value
        },
        changeYear (e) {
            this.selectYearId = e.target.value
        },
        changeEvent (e) {
            this.selectEventId = e.target.value
        },
        changeSelect () {
            this.$root.$emit('setPhotoGrapherData', { name: 'selectSchoolId', value: this.selectSchoolId })
            this.$root.$emit('setPhotoGrapherData', { name: 'selectYearId', value: this.selectYearId })
            this.$root.$emit('setPhotoGrapherData', { name: 'selectEventId', value: this.selectEventId })

            if (this.$route.path !== '/photographer') return

            this.$root.getPhotoData = true

            this.$root.$emit('startLoading')
            this.$root.$emit('getViewPhotos')
            this.$root.$emit('getSetting')
        },
        handleDragOver (event) {
            event.dataTransfer.dropEffect = 'copy'
        },
        async handleDrop (event) {
            const self = this
            const items = event.dataTransfer.items
            if (items) {
                let folderLength = 0
                let folders = []
                let doneEvent = 0
                for (const item of items) {
                    folderLength++
                    const data = item.webkitGetAsEntry()
                    folders.push(data)
                    if (!data || !data.isDirectory) {
                        this.$root.$emit('notification', 'is-danger', 'フォルダのアップロードのみ受け付けています')
                        return
                    }
                }

                this.$root.$emit('notification', 'is-primary', 'アップロードを開始します')
                let failedPhotoLength = 0

                for (const item of folders.sort(compareFileNames)) {
                    const directoryName = item.name
                    let uploadPhotos
                    let res
                    try {
                        uploadPhotos = await readDirectoryFiles(item)
                        const params = this.$parent.requestParams
                        res = await this.axios.post(`${process.env.API_URL}/photographer/event${params}`, {
                            name: directoryName,
                            school_id: this.selectSchoolId,
                            year_id: this.selectYearId
                        })
                    } catch (e) {
                        this.$root.$emit('notification', 'is-danger', `${directoryName} を処理できませんでした。再度アップロードしてください`)
                        return
                    }
                    const eventId = res.data.eventId
                    failedPhotoLength += await upload(this, uploadPhotos, this.selectSchoolId, this.selectYearId, eventId, directoryName)
                    doneEvent++
                    if (doneEvent === folderLength) {
                        if (failedPhotoLength) {
                            self.$root.$emit('notification', 'is-warning', `アップロードに失敗した写真が${failedPhotoLength}件あります。画面を更新し、対象行事の失敗一覧を確認してください`)
                            return
                        }
                        self.$root.$emit('notification', 'is-primary', `全てのアップロードが完了しました（エラー${failedPhotoLength}件）データ更新のため3秒後にリロードします`)
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                    }
                }
            }
        }
    }
}
</script>

<style scoped>

.header {
    display: flex;
    height: 80px;
    padding-top: 15px;
    padding-left: 22px;
    border-bottom: 3px solid #f5f5f5;
}

.name {
    width: 158px;
    font-size: 19px;
    line-height: 50px;
}

.select {
    margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/photographer/Header.vue